<template>
  <div class="detail" id="detail">
    <div class="title-row">
      <h1 class="title" @mouseup="toggleGuaranteeTooltip" v-if="isDesktop">
        {{ property.name }}
      </h1>
      <h1 class="title" v-else @copy="toggleGuaranteeTooltip">
        {{ property.name }}
      </h1>
      <div class="tooltip" :class="{show: showGuaranteeTooltip}">
        Don't forget, we guarantee you won't find a cheaper price elsewhere
      </div>
      <div class="actions">
        <button :class="{ active: isFav}" @click="clickFav" class="action fav" aria-label="Add property to favourites">
          <svg class="ico ico--25">
            <use :xlink:href="isFav ? '#ico-favf' : '#ico-fav'"/>
          </svg>
          <p class="imglnk">{{ isFav ? "Saved" : "Save" }}</p>
        </button>
        <button @click="clickShare" :class="{widgetVisible: showWidget}" class="action share" aria-label="Share property">
          <svg class="ico ico--20">
            <use xlink:href="#icon-share"/>
          </svg>
          <p class="imglnk">Share</p>
        </button>
      </div>
    </div>
    <ul class="crumb" v-if="crumb.length >= 3">
      <li class="crumbitm">
        <a class="crumblnk" :href="crumb[0].url">
          <span>{{ crumb[0].name }}</span>
        </a>
      </li>
      <li class="crumbitm">
        <a class="crumblnk" :href="crumb[1].url">
          <span>{{ crumb[1].name }}</span>
        </a>
      </li>
      <li class="crumbitm">
        <a class="crumblnk" :href="crumb[2].url">
          <span>{{ crumb[2].name }}</span>
        </a>
      </li>
    </ul>
    <p class="ref">ID: S{{ property.id }}</p>
    <div class="info">
      <div class="infoitm">
        <span>Bedrooms</span>
        {{ property.beds }}
      </div>
      <div class="infoitm">
        <span>・Sleeps</span>
        {{ property.sleeps }}
      </div>
      <div class="infoitm">
        <span>・Pets</span>
        <template v-if="property.source === 'Independent Cottages' && property.max_pets >= 3">
          3+
        </template>
        <template v-else>
          {{property.max_pets > 0 ? property.max_pets : property.pets ? "Yes" : "No"}}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Pager from "../shared/pager";
export default {
  components: {Pager},
  data: function () {
    return {
      showWidget: false,
      showGuaranteeTooltip: false
    }
  },
  props: {
    crumb: Array,
    property: Object,
    isFav: Boolean,
    isDesktop: Boolean
  },
  methods: {
    clickFav() {
      this.$emit('clickFav')
    },
    clickShare() {
      if (this.showWidget !== true) {
        this.showWidget = true;

        this.$emit('clickShare')
        setTimeout(() => {
          this.showWidget = false;
        }, 2500)
      }
    },
    toggleGuaranteeTooltip() {
      if (this.showGuaranteeTooltip !== true) {
        this.showGuaranteeTooltip = true;

        setTimeout(() => {
          this.showGuaranteeTooltip = false;
        }, 2500)
      }
    }
  },
  mounted() {
    document.addEventListener('selectionchange', ()=>{
      let selection = window.getSelection().toString();
      if (selection === this.property.name || selection.includes(this.property.name)) {
        setTimeout(() => {
          this.toggleGuaranteeTooltip();
        }, 250)
      }
    });
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.detail {
  margin: 1.25rem;
  position: relative;
  background-color: $col_white;

  .title-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .actions {
      display: flex;
      flex-direction: row;
      column-gap: .625rem;

      .action {
        position: relative;
        background: #F6F6F2;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2rem;
        width: 2rem;
        border-radius: 2rem;

        svg {
          fill: #424242;
          width: 1.563rem;
          height: 1.563rem;
        }

        &.fav {
          svg {
            margin-top: 0.125rem;
          }

          &.active {
            svg {
              fill: $col_primary;
            }
          }
        }

        &.share {
          svg {
            width: 1.25rem;
            height: 1.25rem;
          }
        }
      }
    }
  }

  .title {
    font-size: 1.25rem;
    line-height: 1.5rem;

    &::selection {
      color: $col_white;
      background: $col_primary;
    }
  }

  .tooltip {
    top: 104px;
    z-index: 2;
    opacity: 0;
    padding: 1rem;
    text-align: center;
    font-size: 0.875rem;
    color: $col_white;
    position: absolute;
    border-radius: 1.5rem;
    background: $col_purple;
    transition: top .3s ease-in, opacity .3s ease-in;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.5);

    &.show {
      opacity: 1;
      top: 36px;
    }

    &:before {
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-color: transparent transparent #424F98;
      border-width: 0 0.625rem 0.625rem;
      position: absolute;
      top: -0.625rem;
      left: 2.5rem;
    }
  }

  .crumblnk,
  .ref,
  .infoitm,
  .imglnk {
    font-size: 0.875rem;
    line-height: 1.125rem;

    span {
      font-size: 0.875rem;
      line-height: 1.125rem;
    }
  }

  .ifnoitem {
    padding-right: 0.25rem;
  }

  .crumb {
    display: flex;
    height: 1.25rem;
    min-height: 1.25rem;
  }

  .crumbitm {
    position: relative;
    list-style: none;
    max-width: 7rem;
    @media #{$desktop} {
      max-width: 10rem;
    }
  }

  .crumblnk {
    padding-right: .313rem;
    cursor: pointer;
    display: block;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0.313rem;

    span {
      font-size: 1rem;
      line-height: 1.25rem;
      padding-right: .313rem;
    }

    &::after {
      content: "";
      position: absolute;
      height: 70%;
      top: 15%;
      background: $col_black;
      width: .0625rem;
      right: .313rem;
    }
  }

  .crumbitm:last-of-type .crumblnk:after {
    display: none;
  }

  .ref {
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 400;
  }

  .info {
    display: flex;
    padding-top: .313rem;

    span {
      font-weight: 700;

      &::after {
        content: ":";
        font-weight: 400;
      }
    }
  }

  .widgetVisible {
    &:before {
      content: '';
      position: absolute;
      z-index: 9998;
      top: 1.488rem;
      left: -.75rem;
      width: 0;
      height: 0;
      border-left: 1rem solid transparent;
      border-bottom: 0.313rem solid #474747;
    }

    &:after {
      content: 'Link copied!';
      position: absolute;
      z-index: 9999;
      top: 1.8rem;
      left: -.5rem;
      transform: translateX(-50%);
      width: 4.75rem;
      height: 1.875rem;
      color: $col_white;
      font-size: 0.625rem;
      line-height: 1.875rem;
      text-align: center;
      background: rgba(0, 0, 0, .72);
      border-radius: 0.188rem;
      font-weight: 100;
    }
  }

  .imglnk {
    display: none;

    &:hover {
      text-decoration: underline;
    }

  }

  @media #{$desktop} {
    margin: 0;

    .title {
      font-size: 1.75rem;
      line-height: 2.125rem;
    }

    .info {
      padding-top: .5rem;
    }

    .crumblnk,
    .ref,
    .infoitm,
    .imglnk {
      font-size: 1rem;

      span {
        font-size: 1rem;
      }
    }

    .crumblnk {
      padding-right: .5rem;

      span {
        transition: .3s;

        &:hover {
          color: $col_primary;
        }
      }
    }

    .title-row {
      .actions {
        .action {
          height: auto;
          width: auto;
          background: transparent;
          cursor: pointer;

          &:hover {
            .imglnk {
              color: $col_primary;
            }

            svg {
              fill: $col_primary;
            }
          }

          svg {
            margin-right: .625rem;
            height: 1rem;
            width: 1rem;
          }

          &.fav {
            svg {
              margin-right: .4rem;
              width: 1.25rem;
              height: 1.25rem;
              margin-top: 0;
            }
          }
        }
      }
    }

    .widgetVisible {
      &:before {
        top: 1.688rem;
        left: 1.8rem;
        border-left: 0.313rem solid transparent;
        border-right: 0.313rem solid transparent;
      }

      &:after {
        top: 2rem;
        left: 2rem;
        width: 5.75rem;
      }
    }

    .imglnk {
      display: block;
      transition: .3s;
      font-size: 1rem;
      line-height: 1rem;
    }
  }
}
</style>
